import React, { useState } from "react";
import { Table, Input, Button, Space } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const DriverTable = ({ data, handleEdit, handleDelete }) => {
  const [searchText, setSearchText] = useState("");

  const filteredData = data?.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: "SI No",
      render: (_, __, index) => index + 1,
      align:'center'
    },
    { title: "Name", dataIndex: "driver_name" },
    { title: "License No.", dataIndex: "license_no" },
    { title: "Mobile No.", dataIndex: "mobile" },
    { title: "Experience", dataIndex: "experience" },
    { title: "Status", dataIndex: "status" },
    { title: "Added On", dataIndex: "added_on" },
    { title: "Updated On", dataIndex: "updated_on" },

    // ACTIONS COLUMN
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record.id)}
          />
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.id)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
     <Input
        placeholder="Search..."
        style={{ width: 400, marginBottom: 15 }}
        value={searchText}
        allowClear
        onChange={(e) => setSearchText(e.target.value)}
      />

      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="id"
      />
    </div>
  );
};

export default DriverTable;
